

























































































import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class question extends Vue {
  @Prop(Object)
  question!:object;

  checkValue = [];
  radioValue = '';
  dropdownValue = '';
  dateValue = '';

  optionList=this.question.optionList

  @Watch("question.optionList")
  startChange(newval:number){
    this.optionList = newval
  }

}
